// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__rIYLO","ScrollX":"Scroll_ScrollX__2VnB1","ScrollY":"Scroll_ScrollY__3HsBV"};